<div class="form-group">
  <label>
    How long does the participant have to accept their spot? (optional)
  </label>
  <div class="form-check">
    <input class="form-check-input" type="radio"
           [id]="idPrefix + 'ExpiryModeHours'"
           [name]="idPrefix + 'ExpiryMode'"
           [value]="InviteExpiryMode.hours"
           [disabled]="disabled"
           [ngModel]="expiry.mode"
           (ngModelChange)="update({ mode: $event })">
    <label class="form-check-label" [for]="idPrefix + 'ExpiryModeHours'">
      Number of hours
    </label>
  </div>
  <div class="form-group indented-subsection mt-2"
       *ngIf="expiry.mode === InviteExpiryMode.hours">
    <div class="input-group">
      <input type="number" min="1"
             class="form-control"
             [id]="idPrefix + 'HoursToAccept'"
             [name]="idPrefix + 'HoursToAccept'"
             [disabled]="disabled"
             [class.disabled]="disabled"
             [ngModel]="expiry.hoursToAccept"
             (ngModelChange)="update({ hoursToAccept: $event })">
      <div class="input-group-append">
        <span class="input-group-text">hours</span>
      </div>
    </div>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="radio"
           [id]="idPrefix + 'ExpiryModeDateTime'"
           [name]="idPrefix + 'ExpiryMode'"
           [value]="InviteExpiryMode.dateTime"
           [disabled]="disabled"
           [ngModel]="expiry.mode"
           (ngModelChange)="update({ mode: $event })">
    <label class="form-check-label" [for]="idPrefix + 'ExpiryModeDateTime'">
      Specific date &amp; time
    </label>
  </div>
  <div class="form-group indented-subsection mt-2"
       *ngIf="expiry.mode === InviteExpiryMode.dateTime">
    <app-deadline-date-time-input [idPrefix]="idPrefix + 'Deadline'"
                                  [timeZone]="timeZone"
                                  [disabled]="disabled"
                                  [date]="expiry.deadlineDate"
                                  (dateChange)="update({ deadlineDate: $event })"
                                  [time]="expiry.deadlineTime"
                                  (timeChange)="update({ deadlineTime: $event })"></app-deadline-date-time-input>
  </div>
  <small class="form-text text-danger" *ngIf="validationError()">
    {{ validationError() }}
  </small>
</div>
